import { render, staticRenderFns } from "./setUpRound.vue?vue&type=template&id=617024f2&scoped=true&"
import script from "./setUpRound.vue?vue&type=script&lang=ts&"
export * from "./setUpRound.vue?vue&type=script&lang=ts&"
import style0 from "./setUpRound.vue?vue&type=style&index=0&id=617024f2&lang=scss&scoped=true&"
import style1 from "./setUpRound.vue?vue&type=style&index=1&id=617024f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617024f2",
  null
  
)

export default component.exports